import logo from "../images/logo.jpg";

export default function Logo() {
  return (
    <div className="nav">
      <div className="logo">
        <a href="#">
          <img src={logo} alt="" />
        </a>
      </div>
    </div>
  );
}
